export enum TYPE {
  EXISTING_BIOENTITY = 'EXISTING_BIOENTITY',
  NEW_BIOENTITY = 'NEW_BIOENTITY',

  EXISTING_BATCH = 'EXISTING_BATCH',
  NEW_BATCH_ON_EXISTING_BIOENTITY = 'NEW_BATCH_ON_EXISTING_BIOENTITY',
  NEW_BATCH_ON_NEW_BIOENTITY = 'NEW_BATCH_ON_NEW_BIOENTITY',

  EXISTING_CONTAINER = 'EXISTING_CONTAINER',
}

// "Has" refers to being or being associated with an entity. Both entity and batch fall into this category.
export const HAS_EXISTING_BIOENTITY_TYPES = [
  TYPE.EXISTING_BIOENTITY,
  TYPE.EXISTING_BATCH,
  TYPE.NEW_BATCH_ON_EXISTING_BIOENTITY,
];
export const HAS_NEW_BIOENTITY_TYPES = [TYPE.NEW_BIOENTITY, TYPE.NEW_BATCH_ON_NEW_BIOENTITY];

export const IS_EXISTING_BATCH_TYPES = [TYPE.EXISTING_BATCH];
export const IS_NEW_BATCH_TYPES = [TYPE.NEW_BATCH_ON_EXISTING_BIOENTITY, TYPE.NEW_BATCH_ON_NEW_BIOENTITY];

export const IS_BIOENTITY_TYPES = [TYPE.EXISTING_BIOENTITY, TYPE.NEW_BIOENTITY];
export const IS_BATCH_TYPES = [...IS_EXISTING_BATCH_TYPES, ...IS_NEW_BATCH_TYPES];
export const IS_CONTAINER_TYPES = [TYPE.EXISTING_CONTAINER];

export const IS_CONTAINABLE_TYPES = [...IS_BIOENTITY_TYPES, ...IS_BATCH_TYPES];
